import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Text, Icon, PrimaryButton, Button } from "@artprov/design-system";
import MatchingJudicialDetail from "./MatchingJudicialDetail";
import { getMatchingJudicialDetalle } from "../../../services/matchingJudicial.service";
import { errorService } from "../../../common/utils/functions/error.service";

function DetalleJudicial() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [detalleData, setDetalleData] = useState(null);
    const [error, setError] = useState(null);

    // Extraer parámetros de la URL
    const idEmail = searchParams.get('idEmail');
    const idJuicio = searchParams.get('idJuicio');

    useEffect(() => {
        const fetchData = async () => {
            if (!idEmail) {
                setError("Parámetros inválidos");
                return;
            }

            setLoading(true);
            setError(null);

            try {
                const data = await getMatchingJudicialDetalle(idEmail, idJuicio);
                setDetalleData(data);
            } catch (err) {
                errorService.handleError(err, {
                    userMessage: "No pudimos cargar la información del matching judicial.",
                    origen: "DetalleJudicial.fetchData",
                });
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [idEmail, idJuicio]);

    return (
        <div className="mt-[32px] lg:mx-[95px] mx-[40px]">
            <div className="space-y-6">
                {/* Header con botón volver */}
                <div className="flex items-center gap-4">
                    <Button
                        onClick={() => navigate('/matching-judicial')}
                        variant="ghost"
                        size="xs"
                        startIcon={<Icon icon="keyboard_arrow_left" size="small" />}
                    >
                        Volver
                    </Button>
                </div>

                {/* Estados de carga */}
                {loading && (
                    <div className="flex flex-col items-center justify-center py-16">
                        <Icon icon="progress_activity" size="large" variant="loading" className="text-primary-30" />
                        <Text variant="body1" className="text-tertiary-70 mt-4">
                            Cargando datos...
                        </Text>
                    </div>
                )}

                {error && (
                    <div className="flex flex-col items-center justify-center py-16">
                        <Icon icon="error" size="large" className="text-error-50" />
                        <Text variant="body1" className="text-error-50 mt-4">
                            Error: {error}
                        </Text>
                        <PrimaryButton
                            onClick={() => navigate('/matching-judicial')}
                            className="mt-4"
                        >
                            Volver al inicio
                        </PrimaryButton>
                    </div>
                )}

                {!loading && !error && detalleData && (
                    <div className="max-w-full">
                        <MatchingJudicialDetail
                            matchingData={detalleData.matching}
                            emailBancario={detalleData.emailBancario}
                            extractoBancario={detalleData.extractoBancario}
                            juicioAsociado={detalleData.juicioAsociado}
                            documento={detalleData.documento}
                            historicoEmbargos={detalleData?.historicoEmbargos}
                            idEmail={Number.parseInt(idEmail)}
                        />
                    </div>
                )}

                {!loading && !error && !detalleData && (
                    <div className="flex flex-col items-center justify-center py-16">
                        <Icon icon="search_off" size="large" className="text-tertiary-70" />
                        <Text variant="body1" className="text-tertiary-70 mt-4">
                            No se encontraron datos
                        </Text>
                        <PrimaryButton
                            onClick={() => navigate('/matching-judicial')}
                            className="mt-4"
                        >
                            Volver al inicio
                        </PrimaryButton>
                    </div>
                )}
            </div>
        </div>
    );
}

export default DetalleJudicial;
